import { render, staticRenderFns } from "./AnalyticsLoans.vue?vue&type=template&id=8bca3e3a&"
import script from "./AnalyticsLoans.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsLoans.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports